import { render } from "./Pain.vue?vue&type=template&id=12ccee96&scoped=true"
import script from "./Pain.vue?vue&type=script&lang=js"
export * from "./Pain.vue?vue&type=script&lang=js"

import "./Pain.vue?vue&type=style&index=0&id=12ccee96&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ccee96"]])

export default __exports__